export const routeRelatorios = (routes, checkAuth) => {
    routes.push(
        {
            path: "/relatorio/banda",
            component: () =>
                import(/* webpackChunkName: "banda" */ "../pages/relatorios/Banda.vue"),
            beforeEnter: checkAuth
        },
        {
            path: "/relatorio/busca-cliente-ipv6",
            component: () =>
                import(/* webpackChunkName: "contratos_busca_cliente_ipv6" */ "../pages/relatorios/BuscaClienteIpv6"),
            beforeEnter: checkAuth
        },
        {
            path: "/relatorio/no-latlng",
            component: () =>
                import(/* webpackChunkName: "contratos_sem_ll" */ "../pages/relatorios/ContratosSemLatLong.vue"),
            beforeEnter: checkAuth
        },
        {
            path: "/relatorio/no-mac",
            component: () =>
                import(/* webpackChunkName: "contratos_sem_mac" */ "../pages/relatorios/ContratoSemMac"),
            beforeEnter: checkAuth
        },
        {
            path: "/relatorio/pacpon/sinal",
            component: () =>
                import(/* webpackChunkName: "contratos_pacpon_sinal" */ "../pages/relatorios/PacPonProblemaSinal"),
            beforeEnter: checkAuth
        },
        {
            path: "/relatorio/no-caixa",
            component: () =>
                import(/* webpackChunkName: "contratos_sem_caixa" */ "../pages/relatorios/ContratosSemCaixa.vue"),
            beforeEnter: checkAuth
        },
        {
            path: "/relatorio/busca-contrato",
            component: () =>
                import(/* webpackChunkName: "busca_contrato" */ "../pages/relatorios/BuscaContrato.vue"),
            beforeEnter: checkAuth
        },
        {
            path: "/relatorio/no-ipv6",
            component: () =>
                import(/* webpackChunkName: "contratos_sem_ipv6" */ "../pages/relatorios/ContratoSemIPV6"),
            beforeEnter: checkAuth
        },
        {
            path: "/relatorio/no-vlan",
            component: () =>
                import(/* webpackChunkName: "pacpon_sem_vlan" */ "../pages/relatorios/PacPonSemVLAN"),
            beforeEnter: checkAuth
        },
        {
            path: "/relatorio/no-onuid",
            component: () =>
                import(/* webpackChunkName: "pacpon_sem_onuid" */ "../pages/relatorios/PacPonSemOnuId"),
            beforeEnter: checkAuth
        },
        {
            path: "/relatorio/onu-unregistered",
            component: () =>
                import(/* webpackChunkName: "acoes_registrar_onu" */ "../pages/acoes/ListRegistrarONU"),
            beforeEnter: checkAuth
        },
        {
            path: "/relatorio/cgnat",
            component: () =>
                import(/* webpackChunkName: "acoes_cgnat" */ "../pages/relatorios/Cgnat"),
            beforeEnter: checkAuth
        }
    );
};
